<template>
  <el-tabs class="import-goods-tab" type="border-card" stretch>
    <el-tab-pane :label="generateCustomizeString('importExcel')">
      <el-row class="goods-management" v-loading="goodsLoading" element-loading-text="文件导入/导出中">
        <el-col :span="12" style="padding-top: 10px;">
          <el-col :span="6" class="export-label">
            <span class="import-title">{{ generateCustomizeString('exportGoods') }}</span>
          </el-col>
          <el-col :span="18" class="export">
            <el-button type="primary" style="width: 150px;" @click="exportAction">{{ generateCustomizeString('exportGoods') }}</el-button>
            <div class="el-upload__tip">{{ generateCustomizeString('exportGoodsAsXLSXFormat') }}</div>
          </el-col>

          <el-col :span="6" class="import-label">
            <span class="import-title">{{ generateCustomizeString('importGoods') }}</span>
          </el-col>
          <el-col :span="18" class="import">
            <input type="file" id="files" ref="files" @change="selectFile($event)" />
            <div>
              <el-button
                type="primary"
                style="width: 150px; margin-top: 20px;"
                @click="importData()"
                v-if="this.files.length !== 0"
              >{{ generateCustomizeString('importData') }}</el-button>
              <el-button type="primary" style="width: 150px; margin-top: 20px;" v-else disabled>{{ generateCustomizeString('importGoods') }}</el-button>
              <div class="el-upload__tip">{{ generateCustomizeString('importFormatSameAsExport') }}</div>
            </div>
          </el-col>
        </el-col>
        <el-col :span="12">
          <div style="font-size: 14px; color: #606266;">
            <p style="font-size: 18px; font-weight: bold;">{{ generateCustomizeString('goodsImportExportTip') }}</p>
            <p>{{ generateCustomizeString('goodsImportMsg1') }}。</p>
            <p>{{ generateCustomizeString('goodsImportMsg2') }}</p>
            <p>{{ generateCustomizeString('goodsImportMsg3') }}</p>
            <p>{{ generateCustomizeString('goodsImportMsg4') }}</p>
            <p>{{ generateCustomizeString('goodsImportMsg5') }}</p>
            <p>{{ generateCustomizeString('goodsImportMsg6') }}</p>
            <p>{{ generateCustomizeString('goodsImportMsg7') }}</p>
            <p>{{ generateCustomizeString('goodsImportMsg8') }}</p>
            <p>{{ generateCustomizeString('goodsImportMsg9') }}</p>
          </div>
        </el-col>
      </el-row>
    </el-tab-pane>
    <el-tab-pane :label="generateCustomizeString('importFromPos')" v-loading="posLoading" style="padding: 50px 0 30px;">
      <el-row>
        <el-col :span="12" style="padding-top: 10px;">
          <el-form ref="posForm" :model="posForm" label-width="160px">
            <el-form-item label="POS Platform">
              <el-select v-model="posForm.pos_type" placeholder="Please select" style="width: 300px">
                <el-option
                  v-for="item in posOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                ></el-option>
              </el-select>
              <div v-if="posOptions.message" style="font-size: 14px; color: red">{{ generateCustomizeString('noPosdata') }}</div>
            </el-form-item>
            <el-form-item style="margin-top: 40px;">
              <el-button type="success" @click="showCategoryFromPos" v-if="(posOptions.length > 0) && (posForm.pos_type != null)">{{ generateCustomizeString('importCategories') }}</el-button>
              <el-button type="success" disabled v-else>{{ generateCustomizeString('importCategories') }}</el-button>
              <el-button type="primary" @click="showGoodsFromPos" v-if="(posOptions.length > 0) && (posForm.pos_type != null)">{{ generateCustomizeString('importGoods') }}</el-button>
              <el-button type="primary" disabled v-else>{{ generateCustomizeString('importGoods') }}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12" style="padding-top: 10px;">
          <p style="font-size: 14px; color: #606266;">{{ generateCustomizeString('importPosTips') }}</p>
        </el-col>
      </el-row>

      <el-dialog
        :title="generateCustomizeString('importGoods')"
        :visible.sync="showGoodsFromPosdialog"
        width="80%"
      >
        <div v-loading="goodslistLoading">
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item :title="generateCustomizeString('create')" name="1">
              <el-table
                :data="posGoodsData['add']"
                stripe
                border
                style="width: 100%">
                <el-table-column
                  prop="pos_unique_id"
                  label="POS Unique ID">
                </el-table-column>
                <el-table-column
                  prop="name"
                  :label="generateCustomizeString('merchandiseName')">
                </el-table-column>
                <el-table-column
                  prop="pos_category_name"
                  :label="generateCustomizeString('categories')">
                </el-table-column>
                <el-table-column
                  prop="supplier"
                  :label="generateCustomizeString('merchandiseBrand')">
                </el-table-column>
                <el-table-column
                  prop="price"
                  :label="generateCustomizeString('merchandisePrice') + '(NZD $)'">
                </el-table-column>
                <el-table-column
                  prop="stock"
                  :label="generateCustomizeString('stock')">
                </el-table-column>
              </el-table>
            </el-collapse-item>
            <el-collapse-item :title="generateCustomizeString('update')" name="2">
              <el-table
                :data="posGoodsData['update']"
                stripe
                border
                style="width: 100%">
                <el-table-column
                  prop="pos_unique_id"
                  label="POS Unique ID">
                </el-table-column>
                <el-table-column
                  prop="name"
                  :label="generateCustomizeString('merchandiseName')">
                </el-table-column>
                <el-table-column
                  prop="pos_category_name"
                  :label="generateCustomizeString('categories')">
                </el-table-column>
                <el-table-column
                  prop="supplier"
                  :label="generateCustomizeString('merchandiseBrand')">
                </el-table-column>
                <el-table-column
                  prop="price"
                  :label="generateCustomizeString('merchandisePrice') + '(NZD $)'">
                </el-table-column>
                <el-table-column
                  prop="stock"
                  :label="generateCustomizeString('stock')">
                </el-table-column>
              </el-table>
            </el-collapse-item>
            <el-collapse-item :title="generateCustomizeString('delete')" name="3">
              <el-table
                :data="posGoodsData['delete']"
                stripe
                border
                style="width: 100%">
                <el-table-column
                  prop="pos_unique_id"
                  label="POS Unique ID">
                </el-table-column>
                <el-table-column
                  prop="name"
                  :label="generateCustomizeString('merchandiseName')">
                </el-table-column>
                <el-table-column
                  prop="pos_category_name"
                  :label="generateCustomizeString('categories')">
                </el-table-column>
                <el-table-column
                  prop="supplier"
                  :label="generateCustomizeString('merchandiseBrand')">
                </el-table-column>
                <el-table-column
                  prop="price"
                  :label="generateCustomizeString('merchandisePrice') + '(NZD $)'">
                </el-table-column>
                <el-table-column
                  prop="stock"
                  :label="generateCustomizeString('stock')">
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="showGoodsFromPosdialog = false"
          >{{generateCustomizeString('cancel')}}</el-button>
          <el-button
            type="primary"
            @click="importGoodsFromPos"
          >{{generateCustomizeString('confirm')}}</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="generateCustomizeString('importCategories')"
        :visible.sync="showCategoryFromPosdialog"
        width="80%"
      >
        <div v-loading="categorylistLoading">
          <el-table
            :data="posCategoryData"
            stripe
            border
            style="width: 100%">
            <el-table-column
              prop="pos_id"
              label="POS Category ID">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="generateCustomizeString('categoriesName')">
            </el-table-column>
            <el-table-column
              prop="parent"
              label="Parent ID">
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="showCategoryFromPosdialog = false"
          >{{generateCustomizeString('cancel')}}</el-button>
          <el-button
            type="primary"
            @click="importCategoryFromPos"
          >{{generateCustomizeString('confirm')}}</el-button>
        </div>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import request from '@/utils/request'
import { generateCustomizeString } from '@/utils/i18n'

export default {
  name: 'GoodsManagement',
  data() {
    return {
      goodsLoading: false,
      files: [],
      posForm: {
        key: '',
        pos_type: null
      },
      showGoodsFromPosdialog: false,
      showCategoryFromPosdialog: false,
      posOptions: [],
      posLoading: false,
      posGoodsData: {},
      posCategoryData: [],
      goodslistLoading: false,
      categorylistLoading: false,
      activeNames: ['1']
    }
  },
  methods: {
    generateCustomizeString,
    // uploadSuccess(response, file) {
    //   console.log('上传文件成功', response)
    // },
    // // 上传错误
    // uploadError(response, file) {
    //   console.log('上传失败，请重试！')
    //   console.log(this.importFileUrl)
    // },
    // handlePreview(file) {
    //   console.log(file)
    // },
    // handleRemove(file, fileList) {
    //   console.log(file, fileList)
    // },
    // // 上传前对文件的大小的判断
    // beforeAvatarUpload(file) {
    //   const extension = file.name.split('.')[1] === 'xlsx'
    //   if (!extension) {
    //     this.$message.error('上传文件只能是 xlsx 格式!')
    //   }
    //   return extension
    // },
    importData() {
      this.goodsLoading = true
      var formData = new FormData()
      formData.append('xlsx', this.files[0])
      request({
        url: '/import/goods',
        method: 'post',
        data: formData
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: res.data,
              type: 'success'
            })
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('importFailed'))
        })
        .finally(() => {
          this.goodsLoading = false
        })
    },
    exportAction() {
      this.goodsLoading = true
      request({
        url: '/export/goods',
        method: 'get'
      })
        .then(res => {
          var fileUrl = res.data['file-url']
          window.location.href = fileUrl
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('exportFailed'))
        })
        .finally(() => {
          this.goodsLoading = false
        })
    },
    /*
      Handles the uploading of files
    */
    selectFile(event) {
      // console.log(event)
      const selectFiles = this.$refs.files.files
      // // /*
      // //   Adds the uploaded file to the files array
      // // */
      for (var i = 0; i < selectFiles.length; i++) {
        this.files.push(selectFiles[i])
      }
    },
    handleChange(val) {
      console.log(val)
    },
    posAuthority() {
      this.posLoading = true
      request({
        url: this.$store.state.user.shop_id + '/pos/authroity',
        method: 'get'
      })
        .then(res => {
          this.posOptions = res.data
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.posLoading = false
        })
    },
    showGoodsFromPos() {
      this.showGoodsFromPosdialog = true
      this.goodslistLoading = true
      request({
        url: this.$store.state.user.shop_id + '/pos/' + this.posForm.pos_type.id + '/goods',
        method: 'get'
      })
        .then(res => {
          this.posGoodsData = res.data
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.goodslistLoading = false
        })
    },
    showCategoryFromPos() {
      this.showCategoryFromPosdialog = true
      this.categorylistLoading = true
      request({
        url: this.$store.state.user.shop_id + '/pos/' + this.posForm.pos_type.id + '/category',
        method: 'get'
      })
        .then(res => {
          this.posCategoryData = res.data
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.categorylistLoading = false
        })
    },
    importGoodsFromPos() {
      var data = {
        shop_id: this.$store.state.user.shop_id,
        pos_platform_id: this.posForm.pos_type.id,
        pos_platform_name: this.posForm.pos_type.name
      }

      this.goodslistLoading = true
      request({
        url: '/import/pos/goods',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('importSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('importFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('importFailed'))
        })
        .finally(() => {
          this.showGoodsFromPosdialog = false
        })
    },
    importCategoryFromPos() {
      var data = {
        shop_id: this.$store.state.user.shop_id,
        pos_platform_id: this.posForm.pos_type.id
      }

      this.goodslistLoading = true
      request({
        url: '/import/pos/category',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('importSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('importFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('importFailed'))
        })
        .finally(() => {
          this.showCategoryFromPosdialog = false
        })
    }
  },
  created() {
    this.posAuthority()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.import-goods-tab {
  margin: 30px;
}
.goods-management {
  padding: 80px 60px;
}
.export-label {
  padding-right: 20px;
  text-align: right;
}
.import-title {
  display: inline;
  padding-left: 30px;
  font-size: 14px;
  color: #606266;
  // line-height: 40px;
}
.upload-file {
  display: inline;
  width: 500px;
  // padding-left: 10px;
}
.el-upload__tip {
  // padding-left: 100px;
  padding-top: 5px;
}
.import-label {
  margin-top: 50px;
  padding-right: 20px;
  text-align: right;
}
.import {
  margin-top: 50px;
}
</style>

<style type="text/css">
.el-upload-list {
  width: 60%;
}
</style>
